import { Router } from "@angular/router";
import { RouteUtil } from "../utilities/route.util";

export class UserMenuItemModel {
    text: string;
    icon: string;
    routeUrl: string;
    routeExists: boolean;
  
    constructor(private router: Router, text: string, icon: string, routeUrl: string) { 
      this.text = text;
      this.icon = icon;
      this.routeUrl = routeUrl;
      this.routeExists = RouteUtil.routeExists(this.router, routeUrl);
    }
  }